const HELP_CENTER_SCRIPT_ID = 'help-center-widget-script';
// For production, use: 'https://helpcenter.talview.com/init.js'
const HELP_CENTER_SCRIPT_SRC = 'https://helpcenter.talview.org/init.js';
/**
 * Initialize Help Center widget
 * Dynamically loads the help center script and initializes it with the provided configuration
 */
const initHelpCenter = (params) => {
    if (typeof window === 'undefined')
        return;
    const initializeWidget = (api) => {
        const telemetryConfig = params.telemetryToken
            ? {
                mixpanelToken: params.telemetryToken,
                enableDebug: params.telemetryDebug,
                hostApp: params.telemetryHostApp,
                defaultProps: params.telemetryDefaults,
            }
            : undefined;
        const config = {
            candidate: params.candidate,
            language: params.language,
            limit_languages: params.limit_languages,
            telemetry: telemetryConfig,
            session_identifier: params.sessionIdentifier ?? null,
            question_context: params.questionType ? { type: params.questionType } : undefined,
        };
        api
            .init(config)
            .then(() => {
            console.log('[HelpCenter] Initialized successfully');
        })
            .catch((error) => {
            console.error('[HelpCenter] Initialization failed:', error);
        });
    };
    const onLoad = () => {
        // Check if script is already loaded
        if (document.getElementById(HELP_CENTER_SCRIPT_ID)) {
            // If already loaded and HelpCenter API is available, initialize it
            if (window.HelpCenter) {
                initializeWidget(window.HelpCenter);
            }
            return;
        }
        // Set up callback for when HelpCenter API is ready
        // This callback will be executed by the help-center script after it sets up window.HelpCenter
        window.helpCenterOnLoad = (api) => {
            initializeWidget(api);
        };
        // Create and append the script
        const script = document.createElement('script');
        script.src = HELP_CENTER_SCRIPT_SRC;
        script.id = HELP_CENTER_SCRIPT_ID;
        script.async = true;
        script.onerror = () => {
            console.error('[HelpCenter] Failed to load script');
        };
        document.body.appendChild(script);
    };
    // Add the script when the page loads
    if (document.readyState === 'complete') {
        onLoad();
    }
    else {
        window.addEventListener('load', onLoad, { once: true });
    }
};
export default initHelpCenter;
